import Api from "../config/Axios";


export const getList = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.get(`api/web/pickerpacker/list`, {params:data, ...config});
};

export const getDetail = (token, user_id, id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.get(`api/web/pickerpacker/detail/${id}`, config);
};

export const postAdd = (data, headers) => {
  return Api.post(`api/web/pickerpacker/create`, data, { headers });
};

export const patchEdit = (token, user_id, id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.patch(`api/web/pickerpacker/edit/${id}`, data, config);
};

export const patchEditPasscode = (token, user_id, id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.patch(`api/web/pickerpacker/edit/passcode/${id}`, data, config);
};

export const patchBlock = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.patch(`api/web/pickerpacker/block-status`, data, config);
};

export const patchSuspended = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.patch(`api/web/pickerpacker/suspend-status`, data, config);
};

export const patchApprove = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.patch(`api/web/pickerpacker/approve`, data, config);
};

export const patchAssignZone = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.patch(`api/web/pickerpacker/assign-zone`, data, config);
};













export const getRiderList = (token, user_id, headers) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/rider/list", config);
};

function objToQueryString(obj) {
  const keyValuePairs = [];
  for (const key in obj) {
    keyValuePairs.push(
      encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
    );
  }
  return keyValuePairs.join("&");
}

export const getPickerpackerFiltersPagination = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };

  return Api.get("api/web/pickerpacker/list?keyword=" +
  (data.keyword ? data.keyword : "") +
  "&fleet_id=" +
  (data.fleet_id ? data.fleet_id : "") +
  "&status=" +
  (data.status ? data.status : "") +
  "&id=" +
  (data.id ? data.id : "") +
  "&zones=" +
  (data.zone ? data.zone : "") +
  "&page=" +
  (data.page ? data.page : 1) +
  "&limit=" +
  (data.limit ? data.limit : 100)  
  , config);
};

export const riderAdd = (data, headers) => {
  return Api.post("api/web/rider", data, { headers });
};

export const riderEdit = (riderId, data, headers) => {
  return Api.patch(`api/web/rider/update/${riderId}`, data, { headers });
};

export const riderApprove = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/approve", riderId, config);
};

export const riderBatchAssign = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/assign-batch", riderId, config);
};

export const riderZoneAssign = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/assign-zone", riderId, config);
};

export const riderBlock = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/block", riderId, config);
};

export const refreshTookanData = (token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  // return Api.get("api/web/rider/import", config);
  return Api.get("api/web/rider/fleet-import", config);
};

export const getRiderDetail = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider/detail/${riderId}`, config);
};

export const getRiderMongoIDs = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  // console.log('bulk rider batch api',data)
  return Api.post("api/web/rider/display-ids", data, config);
};

export const getSingleRiderShifts = (riderId, pageNumber, pageSize) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  // console.log("config ", config);
  // return Api.get(`api/app/shift/rider/${riderId}`);
  return Api.get(`api/web/rider/shifts/${riderId}?page=${pageNumber}&limit=${pageSize}`, config);
};

export const getRiderTasks = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  // console.log("config ", config);
  // return Api.get(`api/app/shift/rider/${riderId}`);
  return Api.get(`api/web/tasks/rider/${data.id}?page=${data.page}&limit=${data.limit}`, config);
};

// Rider Brake
export const postRiderBrake = (data, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/break", data, config);
};

// Rider list by zone
// export const getRiderbyZone = (riderId) => {
//   const config = {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//       UserId: parseInt(localStorage.getItem("user_id")),
//     },
//   };
//   return Api.get(`api/web/rider-list/${riderId}`, config);
// };

export const getAvalibleRiderbyZone = (zoneId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider-list-avalible/${zoneId}`, config);
};

export const RiderOngoingShift = (riderId, token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`/api/web/rider/${riderId}/shift/ongoing`, config);
};

// Rider Assign Multi Zones
export const patchRiderZone = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/assign-zone", data, config);
};

// Find rider by zone
export const getRidersByZone = (zoneId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider-list/${zoneId}`, config);
};

export const getRiderForceFree = (rId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/rider/mark-force-free/${rId}`, config);
};


export const patchRiderSuspendStatus = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  // console.log("Rider Services", "api/web/rider/suspend-status", data, config)
  return Api.patch("api/web/rider/suspend-status", data, config);
};

export const patchRiderSyncRms = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch("api/web/rider/sync/rms", data, config);
};
